module.exports = __webpack_public_path__ + "img/1550410560.9177e602.jpg";